import {  useEffect, useRef, useState } from 'react';
import { Button, Form, Grid, Header, Icon, Loader, Modal, ModalContent, Segment } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import { Image } from 'semantic-ui-react';
import * as Yup from 'yup';
import { observer } from 'mobx-react-lite';
import CameraModal from '../../../../app/common/modals/CameraModal';
import MyTextInput from '../../../../app/common/form/MyTextInput';
import { Formik } from 'formik';
import { FileUploadInterface } from '../../../../app/models/Profile';
import ImageTag from '../../../Profile/RenderImage';
import agent from '../../../../app/api/agent';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';
import MultiSectionForm from '../HFCRegister';
import DatePicker from 'react-datepicker';
import {
  CRM_Metadata,
  CRM_MetadataInitialState,
  CRMRegisterIntialState,
  crmRegister,
  RegisterProps,
  metadataDetails
} from '../../../../app/stores/CRMStore/types';
import Components from '../../../../app/common/components';
import { toast } from 'react-toastify';
const CRMRegister = () => {
  const {
    dashboardStore: { dashboard, setRegisterUrlResponse, setOpenCameraModal },
    receivingdeliveryStore,
    commonStore,
    CRMStore: {
      handleCRMMetaDataFieldName,
      MetaDatatemplate,
      handleCRMRegister
    },
  } = useStore();
  const { deleteFile } = receivingdeliveryStore;

  const { devEnv } = commonStore;
  const [camImage, setCamImage] = useState<FileUploadInterface[]>([]);
  const [openCamera, setCameraOpen] = useState(false);
  const [dateString, setDateString] = useState<Date>(new Date());
  const [receivingTitle, setReceivingTitle] = useState<string>('');
  const [LocalMetadata, setLocalMetadata] = useState<CRM_Metadata[]>([
    CRM_MetadataInitialState,
  ]);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const mandatoryFieldsRef = useRef<any>({});
  const [loader,setLoader] = useState(false);
  useEffect(() => {
    handleCRMMetaDataFieldName();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (MetaDatatemplate?.length !== 0) {
      const deliveryParentId = MetaDatatemplate.filter((e)=> e.elementName === 'Deliverables') || '';
      const metadata: CRM_Metadata[] = MetaDatatemplate.map((e) => {
        return {
          ...e,
          readOnly: metadataDetails.includes(e.elementName) || deliveryParentId?.[0]?.elementId === e.parentId || deliveryParentId?.[0]?.elementId === e.elementId ? false : true,
        options: e.options.filter((e)=> e.optionName !== 'Deliverables')
        };
      });
      setLocalMetadata(metadata);
    }
  }, [MetaDatatemplate]);
  
  useEffect(() => {
    setCamImage(dashboard.camImageUrl);
    // eslint-disable-next-line
  }, [dashboard.camImageUrl]);

  const openCameraModal = (title: string) => {
    setReceivingTitle(title);
    setOpenCameraModal(true);
    setCameraOpen(true);
  };
  const handleSubmit = async (values: RegisterProps) => {
    setLoader(true);
    const clientName = LocalMetadata.filter((e)=>e.elementName === 'Client Name')
   const process = LocalMetadata.filter((e)=>e.elementName === 'Process')
   if(clientName[0].elementValue === ''){
    toast.error('Please select the Client Name.')
    setLoader(false);
    return;    
   }
   if(process[0].elementValue === ''){
    toast.error('Please select the Process.')
    setLoader(false);
    return;
   }
   const updatedMetadata = LocalMetadata.map((e) => {
    return {
      ...e,
      readOnly:false,
      elementValue: e.elementType === 'DatePicker' ? 
      e.elementValue || new Date().toLocaleDateString('en-GB') :
      e.elementName === 'Process' ? `${e.elementValue}|Deliverables` :  e.elementValue,
    };
  });
    const payload: crmRegister = {
        title: values.receivingTitle,
        type: values.type,
        barcode: values.barcode_Package || '',
        date: dateString.toLocaleDateString('en-GB'),
        description: values.receiver_Description || '',
        mode_of_Transport: values.mode_of_transport,
        mode_of_Transport_Number: values.mode_of_transport_number,
        sender_Details: values.sender_Details,
        files: camImage,
        metadata: updatedMetadata
    };
    const baseUrl = window.location.origin;

    const reponse = await handleCRMRegister(payload);
     toast.success("Title Create Sucessfully");
    let input=String(reponse);
    const relativePath = input;
    const fullUrl = baseUrl + relativePath;
    setLoader(false);
    window.location.href = fullUrl;
  };
  const handleCancel = () => {
    const updatedData = LocalMetadata.map((e) => {
      return {
        ...e,
        elementValue: '',
      };
    });
    setLocalMetadata(updatedData);
    setDateString(new Date());
    setReceivingTitle('');
    setCamImage([]);
    setRegisterUrlResponse([]);
  };

  const sampleImageArray = [
    '/assets/thumbnail.png',
    '/assets/thumbnail.png',
    '/assets/thumbnail.png',
  ];
  const handleDeleteImage = (url: FileUploadInterface) => {
    if (devEnv) {
      // const splitPath: string[] = url?.url?.split("build") || [];
      agent.Files.deleteLocalFile(url?.url);
      dashboard.updateLocalFileAPI = dashboard.updateLocalFileAPI?.filter(
        (x) => x.id !== url.id,
      );
    }
    deleteFile(url.fileId);
    const filterdata = dashboard.camImageUrl.filter((x) => x.id !== url.id);
    setRegisterUrlResponse(filterdata);
    setCamImage(filterdata);
  };

  const closeCamera = () => {
    setCameraOpen(false);
  };

  const onChangeHandler = (
    e: any,
    { value }: { value: string},
    elements: CRM_Metadata,
  ) => {
    let localElement = [...LocalMetadata];
    if(elements.elementName === "Process"){
      const matchingElementIds = localElement?.filter(element => {
        return value?.includes(element.elementName);
      }).map(element => element.elementId);   
      const deliveryParentId = localElement?.filter(element => {
        return element.elementName === 'Deliverables'
      }).map(element => element.elementId); 
      const metadata: CRM_Metadata[] = localElement.map((e) => {
        const { parentId, elementId, elementName, elementValue } = e;
        const isMatchingElement = matchingElementIds.includes(parentId) || matchingElementIds.includes(elementId) || 
        deliveryParentId.includes(parentId) || deliveryParentId.includes(elementId) ||  metadataDetails.includes(elementName);
        return {
          ...e,
          elementValue: isMatchingElement ? elementValue : '',
          readOnly: !isMatchingElement,
        };
      });
      localElement = metadata
    }
    let result = '';
    let errorTemp = Object.assign({}, errorMessage);
    const index = localElement.findIndex(
      (x) => x.elementName === elements.elementName,
    );

    Array.isArray(value) ? 
    value = value.join(',').replace(/,/g, '|') :
     value = /datepicker/gi.test(elements?.elementType || '')
    ? e?.toLocaleDateString('en-GB') || new Date().toLocaleDateString('en-GB')
    : elements?.elementType === 'DateTime'
      ? new Date(value).toDateString() +
        ' ' +
        new Date(value).toString().split(' ')[4]
      : value;

    localElement[index].elementValue = value;

    // validation

    if (/textbox/gi.test(elements?.elementType || '')) {
      result = commonStore.genericValidation(
        value || '',
        elements?.validation || '',
      );
    }
    if (elements?.isMandatory && !value?.length) {
      result = 'This is mandatory field';
    }

    if (result) {
      errorTemp[`${elements?.elementId}`] = result;
      mandatoryFieldsRef.current[`${elements?.elementId}`] =
        elements?.elementId;
    } else {
      delete errorTemp[`${elements?.elementId}`];
      delete mandatoryFieldsRef.current[`${elements?.elementId}`];
    }
    setErrorMessage(errorTemp);

    setLocalMetadata(localElement);
  };

  return (
    <>
      {<Modal open={loader}  className='ui basic modal'>
        <ModalContent>
        <Loader active inline='centered'>Please wait, this will take a few minutes...</Loader>
        </ModalContent>
        </Modal>}
      {commonStore.filterModeOne?.includes('IRB1') && (
          <Segment clearing className="register-form-segment">
            {dashboard.openCameraModal && openCamera ? (
              <CameraModal
                nameData="receiving"
                workLevelForReceiving={receivingTitle}
              />
            ) : (
              closeCamera
            )}
            <Form clearing style={{ marginTop: '1px' }}>
              <Header
                clearing
                icon="edit"
                size="huge"
                dividing
                as="h1"
                content={
                  (
                    userLanguage[0].Level3InventoryRecievingRegister
                      ?.IRRL01 as any
                  )?.[`${commonStore.language.key}`]
                }
                sub
                color="grey"
              />
            </Form>
            {commonStore.hfcCustomerChanges ? (
              <MultiSectionForm />
            ) : (
              <Formik
                initialValues={CRMRegisterIntialState}
                enableReinitialize={true}
                onSubmit={(values, { resetForm }) => {
                  handleSubmit(values);
                  resetForm();
                }}
                validationSchema={Yup.object({
                  receivingTitle: Yup.string().required('Please Specify Title'),
                  type: Yup.string().required('Please Specify Type'),
                  sender_Details: Yup.string().required(
                    'Please Specify Details',
                  ),
                  mode_of_transport: Yup.string().required(
                    'Please Specify Mode Of Transport',
                  ),
                  mode_of_transport_number: Yup.string().required(
                    'Please Specify Mode Of Transport Number',
                  ),
                  receiver_Description: Yup.string().required(
                    'Please Specify Description',
                  ),
                  barcode_Package: Yup.string().required(
                    'Please Specify Barcode',
                  ),
                })}
              >
                {({ handleSubmit, isSubmitting, values, resetForm,dirty,isValid }) => (
                  <Form fluid className="ui form error" autoComplete="off">
                    <Header
                      clearing
                      style={{ marginTop: '15px' }}
                      icon="clipboard list"
                      content={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRL02 as any
                        )?.[`${commonStore.language.key}`]
                      }
                      sub
                    />

                    <Grid stretched columns={3}>
                      <Grid.Column container fluid>
                        <MyTextInput
                          name="receivingTitle"
                          label={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL03 as any
                            )?.[`${commonStore.language.key}`]
                          }
                          placeholder={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL03 as any
                            )?.[`${commonStore.language.key}`]
                          } //"Title"
                          mandatory
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <MyTextInput
                          name="type"
                          label={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL04 as any
                            )?.[`${commonStore.language.key}`]
                          }
                          placeholder={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRTB02 as any
                            )?.[`${commonStore.language.key}`]
                          }
                          mandatory
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <MyTextInput
                          name="sender_Details"
                          label={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL05 as any
                            )?.[`${commonStore.language.key}`]
                          }
                          placeholder={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRTB03 as any
                            )?.[`${commonStore.language.key}`]
                          }
                        />
                      </Grid.Column>
                    </Grid>
                    <Grid stretched columns={3}>
                      <Grid.Column>
                        <MyTextInput
                          name="mode_of_transport"
                          label={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL06 as any
                            )?.[`${commonStore.language.key}`]
                          } //Mode of Transport
                          placeholder={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRTB04 as any
                            )?.[`${commonStore.language.key}`]
                          } //Mode of Transport
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <MyTextInput
                          name="mode_of_transport_number"
                          label={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL07 as any
                            )?.[`${commonStore.language.key}`]
                          } //Mode of Transport Number
                          placeholder={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRTB05 as any
                            )?.[`${commonStore.language.key}`]
                          } //Mode of Transport Number
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <label>Date</label>
                        <DatePicker
                          selected={dateString}
                          showMonthDropdown
                          showYearDropdown
                          locale={'en'}
                          dateFormat="dd/MM/yyyy"
                          yearDropdownItemNumber={15}
                          scrollableYearDropdown
                          onChange={(date: Date | null) => {
                            if (date) setDateString(date);
                            else setDateString(new Date());
                          }}
                        />
                      </Grid.Column>
                    </Grid>
                    <Grid stretched columns={2}>
                      <Grid.Column>
                        <MyTextInput
                          name="receiver_Description"
                          label={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL09 as any
                            )?.[`${commonStore.language.key}`]
                          } //"Description"
                          placeholder={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRTB07 as any
                            )?.[`${commonStore.language.key}`]
                          } //"Description"
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <MyTextInput
                          name="barcode_Package"
                          label={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL10 as any
                            )?.[`${commonStore.language.key}`]
                          } //"Barcode Package"
                          placeholder={
                            (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRTB08 as any
                            )?.[`${commonStore.language.key}`]
                          } //"Barcode Package"
                        />
                      </Grid.Column>
                    </Grid>

                    <Header
                      icon="camera"
                      content={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRL12 as any
                        )?.[`${commonStore.language.key}`]
                      } //"Photographs of Package "
                      sub
                    />
                    <Header
                      clearing
                      style={{ marginBottom: '10px' }}
                      icon="image"
                      content={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRL13 as any
                        )?.[`${commonStore.language.key}`]
                      } //"Package Views"
                      sub
                    />
                    <Segment>
                      <Grid>
                        {camImage.length !== 0
                          ? camImage.map((url) => {
                              return (
                                <Grid.Column
                                  textAlign={'center'}
                                  key={url.id}
                                  width={2}
                                >
                                  <ImageTag
                                    imageUrl={url.url}
                                    defaultUrl="/assets/documents.jpg"
                                    label={{
                                      as: 'a',
                                      corner: 'right',
                                      icon: 'x',
                                      size: 'tiny',
                                    }}
                                    handleClick={() => handleDeleteImage(url)}
                                  />
                                </Grid.Column>
                              );
                            })
                          : sampleImageArray.map((e, i) => {
                              return (
                                <Image
                                  size="small"
                                  src={e}
                                  alt="/assets/documents.jpg"
                                />
                              );
                            })}
                      </Grid>
                    </Segment>

                    <Button
                      primary
                      floated="right"
                      onClick={() => openCameraModal(values.receivingTitle)}
                      disabled={
                        !(values.receivingTitle !== '' && values.type !== '')
                      }
                      //Add Photographs
                    >
                      <Icon name="camera retro" size="large" />
                      {
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRB01 as any
                        )?.[`${commonStore.language.key}`]
                      }
                    </Button>
                    <br />
                    <br />
                    <br />
                    <label
                      style={{
                        marginLeft: '30%',
                        fontSize: '20px',
                        fontWeight: 'bold',
                      }}
                    >
                      <Icon className="suitcase" />
                      Job Order Form - DMD & RESTORATION
                    </label>
                    <br />
                    <br />
                    <Grid>
                      {LocalMetadata
                      ?.filter((e)=> e.elementName !== 'OutWard Remarks' && e.elementName !== 'InWard Remarks')
                      ?.map((elem: any, index: number) => {
                        return (
                          <>
                            {(elem.elementType === 'Parent' ||
                              (elem.elementName === 'Broadcast Channel Spec' &&
                                elem.elementName !==
                                  'Physical Inspection')) && (
                              <hr style={{ width: '94%' }} />
                            )}
                            <Components
                              disabled={commonStore.filterModeZero?.includes(
                                elem.templateElementId,
                              )}
                              index={index}
                              templateId={elem.templateElementId || ''}
                              elementDetails={elem}
                              onChangeHandler={onChangeHandler}
                              camImage={camImage}
                              errorMessage={errorMessage}
                              RoleChecker={false}
                              onPhotoClick={() => {}}
                              getUploadedFiles={() => {}}
                              onConfirmUser={() => {}}
                              name={'CRM Register'}
                            />
                          </>
                        );
                      })}
                      <hr style={{ width: '94%' }} />
                    </Grid>
                    <Button.Group style={{ marginTop: '40px' }}>
                      <Button
                        onClick={() => {
                          resetForm();
                          handleCancel();
                        }}
                        //Cancel
                      >
                        {
                          (
                            userLanguage[0].Level3InventoryRecievingRegister
                              ?.IRRB03 as any
                          )?.[`${commonStore.language.key}`]
                        }
                      </Button>
                      <Button.Or
                        text={
                          (
                            userLanguage[0].Level3InventoryRecievingRegister
                              ?.IRRB04 as any
                          )?.[`${commonStore.language.key}`]
                        }
                      />
                      <Button
                      
                        loading={isSubmitting}
                        onClick={() => handleSubmit()}
                        content="Submit"
                        positive
                        //Submit
                      >
                        {
                          (
                            userLanguage[0].Level3InventoryRecievingRegister
                              ?.IRRB05 as any
                          )?.[`${commonStore.language.key}`]
                        }{' '}
                      </Button>
                    </Button.Group>
                  </Form>
                )}
              </Formik>
            )}
          </Segment>
        )
      }
    </>
  );
};
export default observer(CRMRegister);
